// src/layout/Header.tsx
import React from "react";
import styled from "styled-components";
import Avatar from "@mui/material/Avatar";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation } from "react-router-dom";

import { clearTokens } from "src/utils/auth";
import { myTheme } from "src/styles/GlobalStyle";

// ✅ 네가 만든 logout API import
import { logoutApi } from "src/api/auth/authApi";

const routeTitleMap: Record<string, string> = {
  "/": "대시보드",
  "/challenge": "챌린지",
  "/healthcare": "설치헬스케어 기준정보",
};

const Header = () => {
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch (e) {
      console.error("logoutApi failed:", e);
    } finally {
      clearTokens();
      window.location.replace("/login");
    }
  };

  const title = routeTitleMap[location.pathname] ?? "";

  return (
    <HeaderWrapper>
      <PageTitle>{title}</PageTitle>
      <UserSection>
        <LogoutButton onClick={handleLogout}>
          <LogoutIcon />
          Logout
        </LogoutButton>
        <Avatar sx={{ bgcolor: "#f43f5e", width: 32, height: 32 }}>G</Avatar>
      </UserSection>
    </HeaderWrapper>
  );
};

export default Header;

// --- styles ---
const HeaderWrapper = styled.header`
  height: 64px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
`;

const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoutButton = styled.button`
  background-color: ${myTheme.colors.primary};
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;

  svg {
    margin-right: 6px;
  }

  &:hover {
    background-color: #4f46e5;
  }
`;
